import { makeStyles } from 'tss-react/mui';
import { BACKGROUND_GREY_LIGHT } from 'utilities/colors';

export const useRecommendedAIToolsStyles = makeStyles()((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    gap: 12,
    paddingTop: 52,
    [theme.breakpoints.down('laptop')]: {
      paddingTop: 30,
    },
  },
  title: {
    fontWeight: 500,
    fontSize: '1.125rem',
    textTransform: 'uppercase',
  },
  toolsContainer: {
    width: '100%',
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: '24px',
    [theme.breakpoints.down('laptop')]: {
      gridTemplateColumns: '1fr',
    },
  },
  cardClass: {
    padding: 16,
    borderRadius: '5px',
    '& > div > div:nth-of-type(1) > span:first-of-type': {
      fontSize: '1rem',
    },
    '& > div > div:nth-of-type(2)': {
      backgroundColor: BACKGROUND_GREY_LIGHT,
      boxShadow: 'none',
    },
  },
  btn: {
    textTransform: 'uppercase',
    width: 'fit-content',
    marginTop: 10,
    alignSelf: 'center',
  },
}));
